<template>
    <div>
        <h2 class="col-lg-12 text-center mb-3">{{ $t('edit') }}</h2>
        <ServiceValueForm :baseServiceValue="keyValue" :loading="loading" @submit-requested="submitRequested"></ServiceValueForm>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ServiceValueForm from './ServiceValueForm.vue'
import router from '@/router';

export default {
    data() {
        return {
            keyValue: null,
            name: this.$route.params.name,
            loading: true
        }
    },
    components: { ServiceValueForm },
    computed: {
        ...mapState('serviceValue', ['getServiceValueDetailsOutput']),
    },
    methods: {
        ...mapActions('serviceValue', ['getServiceValueDetails']),
        ...mapActions('serviceValue', ['putServiceValue']),
        submitRequested(serviceValue) {
            this.putServiceValue(serviceValue);
        },
    },
    mounted: function () {
        
        if (!this.$route.query || !this.$route.query.id) {
            console.error("Key is undefined or null"); 
            router.push({ name: 'ServiceValueList' });
            return; 
        }

        this.getServiceValueDetails(this.$route.query.id);
    },
    watch: {
        getServiceValueDetailsOutput: function(keyValueOutput) {
            if (!keyValueOutput || !keyValueOutput.data) {
                router.push({ name: 'ServiceValueList' });
            } else {
                this.keyValue = keyValueOutput.data;
                console.log(this.keyValue, "keyValue");
                this.loading = false;
            }
        }
    }
}
</script>